import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { SubheaderService, MenuAsideService } from '../../../../core/_base/layout';
import { MenuSectionService } from '../../../../provider/menu-section.service';
import { RequestsService } from '../../../../provider/requests.service';
import { MenuItemModel } from '../../../models/menu-item.model';
import { MenuSectionModel } from '../../../models/menu-section.model';

@Component({
  selector: 'kt-menu-item',
  templateUrl: './menu-item.page.html'
})
export class MenuItemPage implements OnInit {
  ID: number;
  currentSection: MenuSectionModel;
  isReservation = false;

  constructor(
    private subheaderService: SubheaderService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private router: Router,
    private menuSectionService: MenuSectionService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public requestService: RequestsService,
    private menuAside: MenuAsideService
  ) {
    this.menuAside.pathname$.next(window.location.pathname);
  }

  ngOnInit() {
    this.ID = Number(this.route.snapshot.params.id);

    if (isNaN(this.ID)) {
      this.router.navigateByUrl('/home').then();
      return;
    }

    this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item/' + this.ID).subscribe(

      (data: MenuItemModel) => {
        if (data.booking_system == 'onDemand' || data.menu_section_id == 116) {
          this.isReservation = true;
        }

        this.menuSectionService.getSectionByID(data.menu_section_id).subscribe(
          (menuSection: MenuSectionModel) => {
            this.currentSection = menuSection;
            this.changeDetectorRef.markForCheck();
          }
        );

        let page = '/home/menu-section/' + data.menu_section_id;
        if (data.menu_section_id == 113 || data.menu_section_id == 114 || data.menu_section_id == 115 || data.menu_section_id == 117 || data.menu_section_id == 130) {
          page = '/home';
        }

        const section = this.menuSectionService.section_change$.getValue();
        let title = section.title;

        if (page == '/home') {
          this.subheaderService.breadcrumbs$.next([{ title: 'Home', page: '/' }]);
        } else if (section.title == '' || section.id != data.menu_section_id) {
          this.menuSectionService.getSectionByID(data.menu_section_id).subscribe(
            (menuSection: MenuSectionModel) => {
              this.menuSectionService.section_change$.next(menuSection);
              title = menuSection.title;
              this.subheaderService.breadcrumbs$.next([{ title: 'Home', page: '/' }, { title, page }]);
            }
          );

        } else {
          this.subheaderService.breadcrumbs$.next([{ title: 'Home', page: '/' }, { title, page }]);
        }

        this.subheaderService.title$.next({
          title: data.name,
          desc: ''
        });
      },
      (err) => {
        console.log(err);
        this.router.navigateByUrl('/home').then();
      }
    );

    this.requestService.getRequest();
  }


}
